import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';
import './agenda.css';
//import { agenda } from '../../json/agenda';

const Agenda = () => {
    const [events, setEvents] = useState([]);
    const [modalStatus, setModalStatus] = useState(false);
    const [eventData, setEventData] = useState([]);

    useEffect(() => {
        setEvents(window._my_agenda);
        window.scrollTo(0, 0);
    }, []);


    const handleEventClick = (eventClickInfo) => {
        // Obtener información del evento
        setModalStatus(true);
        const eventTitle = eventClickInfo.event.title;
        const eventPlace = eventClickInfo.event.extendedProps.place;
        const eventDescription = eventClickInfo.event.extendedProps.description;
        
        setEventData([eventTitle, eventPlace, eventDescription]);
    };

    const calendarOptions = {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        weekends: true,
        events: events,
        eventClick: handleEventClick // Agregar manejador de eventos
    };

    return (
        <>
            <div id='calendar'>
                <div className='container'>
                    <div className='row'>
                        <div>
                            <h3 className='title'>Agenda del Secretario</h3>
                            <hr className='hr-gob'/>
                        </div>
                        {
                            modalStatus ? 
                            <div id='modal-agenda'>
                                <div className='close-icon'>
                                    <i className="fa-sharp fa-solid fa-xmark" onClick={() => {setModalStatus(false)}}/>
                                </div>
                                {/*<p className='agenda-title'>{ eventData[0] }</p>*/}
                                <p className='agenda-location'><i className="fa-solid fa-location-dot"></i>{ eventData[1] }</p>
                                <iframe className='twitter-embed' srcDoc={`<blockquote class="twitter-tweet"><p lang="es" dir="ltr">${eventData[0]}<a href="https://twitter.com/hashtag/ElHidalgoQueQueremos?src=hash&amp;ref_src=twsrc%5Etfw">#ElHidalgoQueQueremos</a> <a href="https://t.co/oo2uo2ujvl">https://t.co/oo2uo2ujvl</a></p>&mdash; CARLOS HENKEL ESCORZA (@carekad) <a href="${eventData[2]}?ref_src=twsrc%5Etfw">${eventData[3]}</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`}></iframe>
                                {/*<iframe id="url" srcDoc={`<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Brindamos atención a los empresarios para apoyar iniciativas de inversión que fortalezcan la economía del estado, generen empleos y contribuyan al desarrollo sostenible de Hidalgo.<a href="https://twitter.com/hashtag/ElHidalgoQueQueremos?src=hash&amp;ref_src=twsrc%5Etfw">#ElHidalgoQueQueremos</a> <a href="https://t.co/oo2uo2ujvl">https://t.co/oo2uo2ujvl</a></p>&mdash; CARLOS HENKEL ESCORZA (@carekad) <a href="https://twitter.com/carekad/status/1889829978059186504?ref_src=twsrc%5Etfw">February 13, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`} className='twitter-embed' frameborder="0" scrolling="auto" allowTransparency="true" allow="encrypted-media"></iframe>
                                */}
                            </div> :null
                        }
                        <div className='container'>
                            <div className="agenda">
                                <FullCalendar {...calendarOptions} locale={esLocale}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    )
}

export default Agenda;
